var React = require('react');

var ReactDOM = require('react-dom');

var $ = require("jquery");
var smartScroll = require("../vendor/jquery.smartScroll");

var InsuranceClauseDialog = React.createClass({
  propTypes: {
     pid: React.PropTypes.string,
     pname: React.PropTypes.string
  },


  getInitialState(){
     return {
         left: this.props.left
     }
  },

  openDialog(){
    var pid = this.props.pid;
    var dialog = this.getDialog('<iframe src="//m.xcds.com.cn/topic/insurance-policy/?pid=' + pid + '"></iframe>');
    dialog.show();
  },

  getDialog(content){
    var tpl = [
        '<div class="mod-dialog insurance-clause-dialog" style="z-index: 3000; display:none;">',
            '<div class="hd">',
                '<h3>保险权益：</h3>',
                '<span class="close"></span>',
            '</div>',
            '<div class="bd">',
              content,
            '</div>',
        '</div>'
    ].join('');

    $("body").append(tpl).append('<div class="mod-overlay insurance-clause-dialog-overlay" style="z-index: 2999; display: block;"></div>');

    return {
      show:function(){
        var dialog = $(".insurance-clause-dialog")
        , winWidth = $(window).width()
        , winHeight = $(window).height()
        , width = dialog.width()
        , height = dialog.height()
        ;

        dialog.css({
          top: winHeight / 2 - height / 2,
          left: winWidth / 2 - width / 2
        }).show();
   
        var scroll_top = $(window).scrollTop();
        
        $.smartScroll(dialog);
        $("html").addClass("page-scroll-fixed");
        dialog.find(".close").on("click", function(){
          dialog.hide().remove();
          $('.insurance-clause-dialog-overlay').remove();
          $("html").removeClass("page-scroll-fixed");
          $(window).scrollTop(scroll_top);
        });

      }
    };

  },

  render(){
    return <a onClick={ this.openDialog } title="保险权益" className="btn attach-info-btn js-insurance-info">说明</a>;
    
  }
});

module.exports = InsuranceClauseDialog;



/** WEBPACK FOOTER **
 ** ./script/detail-m/InsuranceClauseDialog.jsx
 **/